import { render, staticRenderFns } from "./CurrentAlertCount.vue?vue&type=template&id=e7efaf90"
import script from "./CurrentAlertCount.vue?vue&type=script&lang=js"
export * from "./CurrentAlertCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports